import { Card, FormControl, Grid, Switch } from '@deckee/deck-hand';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTE_MAP } from '../../../../services/route/route-names';
import {
  transitionToNextRoute,
  transitionToPreviousRoute,
} from '../../../../services/route/route-navigation';
import {
  selectWeatherConfig,
  setWeather,
} from '../../../../services/store/modules/app-controls';
import { handleUpdateWeatherConfig } from '../../../helpers/settings-helpers';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import { LayoutBody } from '../../../layouts/components/LayoutBody/LayoutBody';

const WeatherSettingsPage = () => {
  const dispatch = useDispatch();
  const weatherConfig = useSelector(selectWeatherConfig);

  const [defaultWeatherLocation, setDefaultWeatherLocation] = React.useState(
    weatherConfig.weatherOnMapCenter ? 'Centre of map' : 'Your location',
  );
  const [defaultAppStartup, setDefaultAppStartup] = React.useState(
    weatherConfig.weatherOnStartup ? 'Weather' : 'Map',
  );

  useEffect(() => {
    dispatch(setWeather({}));
  }, [dispatch]);

  return (
    <BasicDrawerLayout
      heading="Weather"
      onBack={() => transitionToPreviousRoute()}
      onClose={() => transitionToNextRoute(ROUTE_MAP)}
    >
      <LayoutBody>
        <Card>
          <Card.Body>
            <Grid gutters={20} margins={0}>
              <Grid.Column>
                <FormControl label="Default weather location">
                  <Switch.Group
                    name="weather-location"
                    value={defaultWeatherLocation}
                    onChange={(e) => {
                      const { value } = e.target;
                      setDefaultWeatherLocation(value);
                      handleUpdateWeatherConfig(
                        dispatch,
                        weatherConfig,
                        'weatherOnMapCenter',
                        value === 'Centre of map',
                      );
                    }}
                  >
                    <Switch id="Your location" value="Your location">
                      Current location
                    </Switch>
                    <Switch id="Centre of map" value="Centre of map">
                      Centre of map
                    </Switch>
                  </Switch.Group>
                </FormControl>
              </Grid.Column>
              <Grid.Column>
                <FormControl label="Default app startup">
                  <Switch.Group
                    name="app-startup"
                    value={defaultAppStartup}
                    onChange={(e) => {
                      const { value } = e.target;
                      setDefaultAppStartup(value);
                      handleUpdateWeatherConfig(
                        dispatch,
                        weatherConfig,
                        'weatherOnStartup',
                        value === 'Weather',
                      );
                    }}
                  >
                    <Switch id="Map" value="Map">
                      Map
                    </Switch>
                    <Switch id="Weather" value="Weather">
                      Weather
                    </Switch>
                  </Switch.Group>
                </FormControl>
              </Grid.Column>
            </Grid>
          </Card.Body>
        </Card>
      </LayoutBody>
    </BasicDrawerLayout>
  );
};

export default WeatherSettingsPage;
